import { createSlice } from "@reduxjs/toolkit"

const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("student") !== null && localStorage.getItem("student") !== undefined && localStorage.getItem("student") !== "") {
    data = [JSON.parse(localStorage.getItem("student"))]
}

const Insider = createSlice({
    name: "todos",
    initialState: data,
    reducers: {
        getdata: (state, action) => {
            return action.payload.data || [];
        },

        logout_: (state, action) => {
            localStorage.clear()
            state = []
            return state
        },

        updatestudentdata: (state, action) => {
            return action.payload.data || [];
        },

        updateStudent: (state, action) => {
            const { studentId, updatedData } = action.payload;
            const studentIndex = state.findIndex(student => student._id === studentId);
            if (studentIndex !== -1) {
                state[studentIndex] = { ...state[studentIndex], ...updatedData };
            }
            return state;
        },

        deleteStudent: (state, action) => {
            const studentId = action.payload;
            return state.filter(student => student._id !== studentId);
        },

        updateCanteenPayments: (state, action) => {
            const { paymentData, selectedDate } = action.payload;
            
            // Update each student's canteen data locally
            paymentData.forEach(payment => {
                const studentIndex = state.findIndex(student => student._id === payment.id);
                if (studentIndex !== -1) {
                    // Check if payment for this date already exists
                    const existingPaymentIndex = state[studentIndex].canteen?.findIndex(
                        canteenEntry => canteenEntry.date === selectedDate
                    );
                    
                    if (existingPaymentIndex !== -1) {
                        // Update existing payment (overwrite)
                        state[studentIndex].canteen[existingPaymentIndex] = payment.data.canteen;
                    } else {
                        // Add new payment
                        if (!state[studentIndex].canteen) {
                            state[studentIndex].canteen = [];
                        }
                        state[studentIndex].canteen.push(payment.data.canteen);
                    }
                }
            });
            return state;
        },

        // Update single student attendance - Efficient approach
        updateStudentAttendance: (state, action) => {
            const { studentId, attendanceData, term, date } = action.payload;
            const studentIndex = state.findIndex(student => student._id === studentId);
            
            if (studentIndex !== -1) {
                // Initialize attendance structure if it doesn't exist
                if (!state[studentIndex].attendance) {
                    state[studentIndex].attendance = {};
                }
                
                // Initialize term structure if it doesn't exist
                if (!state[studentIndex].attendance[term]) {
                    state[studentIndex].attendance[term] = [];
                }
                
                // Check if attendance already exists for this date
                const existingIndex = state[studentIndex].attendance[term].findIndex(
                    att => att.date === date
                );
                
                if (existingIndex !== -1) {
                    // Update existing attendance
                    state[studentIndex].attendance[term][existingIndex] = attendanceData;
                } else {
                    // Add new attendance record
                    state[studentIndex].attendance[term].push(attendanceData);
                }
            }
            return state;
        },

        // Update multiple students attendance - Efficient approach
        bulkUpdateStudentAttendance: (state, action) => {
            const { attendanceUpdates } = action.payload;
            
            attendanceUpdates.forEach(update => {
                const { studentId, attendanceData, term, date } = update;
                const studentIndex = state.findIndex(student => student._id === studentId);
                
                if (studentIndex !== -1) {
                    // Initialize attendance structure if it doesn't exist
                    if (!state[studentIndex].attendance) {
                        state[studentIndex].attendance = {};
                    }
                    
                    // Initialize term structure if it doesn't exist
                    if (!state[studentIndex].attendance[term]) {
                        state[studentIndex].attendance[term] = [];
                    }
                    
                    // Check if attendance already exists for this date
                    const existingIndex = state[studentIndex].attendance[term].findIndex(
                        att => att.date === date
                    );
                    
                    if (existingIndex !== -1) {
                        // Update existing attendance
                        state[studentIndex].attendance[term][existingIndex] = attendanceData;
                    } else {
                        // Add new attendance record
                        state[studentIndex].attendance[term].push(attendanceData);
                    }
                }
            });
            return state;
        }
    }
})

export const { 
    logout_, 
    updatestudentdata, 
    login, 
    getdata, 
    updateStudent, 
    deleteStudent, 
    updateCanteenPayments,
    updateStudentAttendance,
    bulkUpdateStudentAttendance
} = Insider.actions;
export default Insider.reducer;
